export const RETAIL_GENERAL_SETTINGS_TAB = {
  ACCOUNTS_AND_CREDITS: { id: 1, path: 'accounts-and-credits' },
} as const
